import React, { useState, useEffect } from "react";
import { IoMdAdd } from "react-icons/io";
import { IoClose, IoEyeOff, IoEye } from "react-icons/io5";
import ServerTable from "../../settingTable.js/ServerTable";
import { IoSearch } from "react-icons/io5";
import { MdFilterList } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";

import { getAllServer, saveNewServer } from "../../store/actions/server";
import { toast } from "react-toastify";

const Server = ({ onSearch }) => {
  // const dispatch = useDispatch();
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("all");

  const [filterQuery, setFilterQuery] = useState({
    limit: "10",
    page: "1",
  });
  const [currentUser, setCurrentUser] = useState({
    setting: { allregistration: false },
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [isRotated, setIsRotated] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  // const [serverList, setServerList] = useState<ServerItem[0]>([]);
  const [serverList, setServerList] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSaveServer = (e) => {
    e.preventDefault();
    console.log("Form data being sent:", formData);
    dispatch(saveNewServer(formData));
    setFormData({
      name: "",
    });
    toast.success("New data center location saved Successfully!", {
      position: "top-right", // Use string instead of POSITION.TOP_RIGHT
      autoClose: 600,
      onClose: () => {
        fetechAllServer();
      },
    });

    setIsModalOpen(false);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const fetechAllServer = () => {
    dispatch(getAllServer(filterQuery));
  };

  useEffect(() => {
    fetechAllServer();
  }, [dispatch, filterQuery, setFilterQuery]);
  const togglePasswordVisibility = () => setShowPassword(!showPassword);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setFilterQuery((prevQuery) => ({
      ...prevQuery,
      status: tab === "active" ? "1" : tab === "inactive" ? "0" : undefined,
    }));
  };

  const handleToggle = () => {
    setCurrentUser((prevUser) => ({
      ...prevUser,
      setting: {
        ...prevUser.setting,
        allregistration: !prevUser.setting.allregistration,
      },
    }));
  };
  // redux logic
  const server = useSelector((state) => state.server);

  useEffect(() => {
    setServerList(Array.isArray(server?.servers) ? server.servers : []);
  }, [server]);
  const userProducts = [
    {
      name: 'Rishi"',
      email: "rishi@gmail.com",
      phone: "8077044335",
      roleId: "user",
      status: true,
    },
    // Add additional user products here
  ];

  const userHeader = [
    { key: "Name" },
    { key: "Email" },
    { key: "Phone" },
    { key: "Role Id" },
    { key: "Status" },
    { key: "Action" },
  ];
  // search functionality....
  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
    setShowCloseButton(value.length > 0);
    setIsRotated(true);

    // Search on each keystroke
    onSearch({
      limit: "10",
      page: "1",
      keyword: value,
    });
  };

  const handleSearchClear = () => {
    setSearchText("");
    onSearch({
      limit: "10",
      page: "1",
      keyword: "",
    });
    setShowCloseButton(false);
    setIsRotated(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    onSearch({
      limit: "10",
      page: "1",
      keyword: searchText.trim(),
    });
    setShowCloseButton(true);
    setIsRotated(true);
  };

  useEffect(() => {
    // Reset rotation after animation
    if (isRotated) {
      const timer = setTimeout(() => {
        setIsRotated(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [isRotated]);
  // filter functionality....
  const toggleCalendar = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };

  const handleFilter = (e) => {
    e.preventDefault(); // Prevent default form submission (if inside a form)
  };

  return (
    <>
      <div className="flex flex-col relative">
        {/* Header Section */}
        <div className="fixed w-full overflow-x-auto md:w-[calc(100%-16rem)] lg:max-w-[calc(100%-16rem)] mt-[5.5px] md:mt-[4.8px] lg:mt-1 bg-top mx-auto p-2 md:p-1 lg:p-1  rounded-lg flex flex-col sm:flex-row items-center gap-3 md:gap-4 lg:gap-2  md:justify-between lg:justify-between z-30 !bg-[#cbd5e0]">
          <div className="flex items-center w-full sm:w-auto lg:w-2/5 md:w-2/5 perspective-1000">
            <form
              className="flex w-full transform-style-3d"
              onSubmit={handleSearch}
            >
              <label htmlFor="default-search" className="sr-only">
                Search
              </label>
              <div
                className={`relative w-full transition-transform duration-500 ${
                  isRotated ? "rotate-y-180" : ""
                }`}
              >
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none transform-style-3d">
                  <IoSearch
                    className={`w-3 h-3 text-gray-500 dark:text-gray-400 transition-transform duration-300 ${
                      isRotated ? "rotate-y-180" : ""
                    }`}
                  />
                </div>
                <input
                  type="search"
                  id="default-search"
                  name="defaultSearch"
                  value={searchText}
                  onChange={handleSearchText}
                  className="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-0 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500 transform-style-3d hover:shadow-xl transition-all duration-300"
                  placeholder="Search..."
                  required
                />
                <button
                  type="submit"
                  className="absolute right-0 bottom-1 top-1 bg-[#02256d] hover:bg-blue-900 text-white font-medium rounded-lg text-sm px-4 py-0 mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 transform hover:scale-105 transition-transform duration-300 hover:shadow-lg"
                >
                  Search
                </button>
                {showCloseButton && (
                  <button
                    type="button"
                    onClick={handleSearchClear}
                    className="absolute right-20 bottom-1 top-1 bg-red-500 hover:bg-red-700 text-white font-medium rounded-lg text-sm px-2 py-0 mr-2 transform hover:scale-105 transition-transform duration-300 hover:shadow-lg"
                  >
                    Clear
                  </button>
                )}
              </div>
            </form>
          </div>{" "}
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 lg:gap-4 w-full lg:w-auto md:w-auto">
            <div className="w-full lg:w-fit">
              {/* Filter Button */}
              <button
                onClick={toggleCalendar}
                className="flex items-center gap-2 justify-center w-full sm:w-auto hover:bg-[#02256d] text-[#02256d] hover:text-white border-[1px] border-[#02256d] font-medium rounded-lg text-sm px-4 py-1 transition-transform transform hover:scale-105"
              >
                <MdFilterList /> Filter
              </button>

              {/* Calendar Modal */}
              {isCalendarOpen && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-gray-900 bg-opacity-50"
                  onClick={toggleCalendar} // Close modal when clicking outside
                >
                  <div
                    className="relative p-4 w-full max-w-xs sm:max-w-sm mx-auto"
                    onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
                  >
                    <div className="relative bg-card rounded-lg shadow">
                      {/* Modal Header */}
                      <div className="flex items-center justify-between p-4 border-b rounded-t">
                        <h3 className="text-lg font-semibold text-text">
                          Select Dates
                        </h3>
                        <button
                          type="button"
                          className="text-text bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-600"
                          onClick={toggleCalendar}
                        >
                          <IoClose className="w-5 h-5" />
                        </button>
                      </div>

                      {/* Modal Body */}
                      <form onSubmit={handleFilter} className="p-4">
                        <div className="grid gap-4 mb-4">
                          <div>
                            <label
                              htmlFor="dateFrom"
                              className="block mb-2 text-sm font-medium text-text"
                            >
                              Date From
                            </label>
                            <input
                              type="date"
                              id="dateFrom"
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                              required
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="dateTo"
                              className="block mb-2 text-sm font-medium text-text"
                            >
                              Date To
                            </label>
                            <input
                              type="date"
                              id="dateTo"
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                              required
                            />
                          </div>
                        </div>
                        <button
                          type="submit"
                          className="w-full mt-2 justify-center text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                          Submit
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>{" "}
            {/* <AddNewButton /> */}
            <div className="w-full md:w-fit lg:w-fit">
              <button
                onClick={toggleModal}
                className="flex items-center gap-2  justify-center w-full md:w-[120px] sm:w-auto bg-[#fdbc12] text-black font-medium rounded-lg text-sm px-4 py-1 transition-transform transform hover:scale-105"
              >
                <IoMdAdd /> Add New
              </button>
              {/* Modal */}
              {isModalOpen && (
                <div className="fixed inset-0 mt-4 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
                  <div className="relative p-4 w-full max-w-md h-auto overflow-hidden">
                    <div className="relative bg-card rounded-lg shadow max-h-[90vh] overflow-y-auto">
                      {/* Modal Header */}
                      <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                        <h3 className="text-lg font-semibold text-text">
                          Add New Data Location
                        </h3>
                        <button
                          type="button"
                          className="text-text bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600"
                          onClick={toggleModal}
                        >
                          <IoClose className="w-5 h-5" />
                        </button>
                      </div>

                      {/* Modal Body */}
                      <form className="p-4 md:p-5" onSubmit={handleSaveServer}>
                        <div className="grid gap-4 mb-4 grid-cols-1">
                          <div>
                            <label
                              htmlFor="name"
                              className="block mb-2 text-sm font-medium text-text"
                            >
                              Name
                            </label>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                              placeholder="Enter Server Name"
                              required
                            />
                          </div>
                        </div>

                        <button
                          type="submit"
                          className="w-full justify-center text-white inline-flex items-center bg-[#02256d] hover:bg-blue-950 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                          Save
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="lg:mt-[3.3rem] md:mt-[3.3rem] mt-[11.2rem] relative">
          {/* Tab and Toggle Section */}
          <div className="fixed lg:max-w-[calc(100%-16rem)] md:w-[calc(100%-16rem)] flex flex-row justify-between items-center gap-6 w-full text-center bg-card p-1  shadow-md z-20 !bg-[#cbd5e0]">
            {/* Title */}
            <h2 className="text-base mx-1 font-medium text-text">
              Server Name
            </h2>

            {/* Toggle Switch */}
            <label className="items-center cursor-pointer hidden">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={currentUser?.setting?.allregistration}
                onChange={handleToggle}
              />
              <div className="relative w-11 h-5 bg-blue-950 rounded-full dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:bg-blue-900 after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600" />
              <span className="ml-3 text-sm font-medium text-text">
                External User
              </span>
            </label>

            {/* Tabs */}
            <ul
              className="flex flex-wrap -mb-px text-sm font-medium text-text"
              role="tablist"
            >
              {["all", "active", "inactive"].map((tab) => (
                <li className="mr-2" role="presentation" key={tab}>
                  <button
                    className={`px-4 py-2 border-b-2 ${
                      activeTab === tab
                        ? "border-[#02256d] text-[#02256d]"
                        : "border-transparent hover:text-[#02256d]"
                    }`}
                    id={tab}
                    type="button"
                    onClick={() => handleTabClick(tab)}
                    role="tab"
                    aria-selected={activeTab === tab}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          {/* User Table */}
          <div className="mt-12">
            <ServerTable userHeader={userHeader} userProducts={serverList} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Server;
